export const farming = {
    "farming_titel_card_title" : "Precise Farming Mode",
    "farming_titel_card_text" : "Are your field boundaries in ITRF2014 and you want to work with APOS? With this tool you can easily convert into the APOS ETRS89 coordinate system.",
    "farming_coord_input_title" : "Points to transform"
}